import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import '@ionic/react/css/core.css';

// Default all fetches to include the httpOnly session cookie.
// Auto-logout on session-expired 401s only — NOT on every /api/ 401.
//
// SECURITY_AUDIT H-13: previously this matched on `url.startsWith('/api/')`
// alone, so every operation-specific 401 (expired media token, bad refresh
// token, invalid OAuth grant, slow_down on device polling, etc.) yanked
// the user back to the login screen. Media tokens expire every hour, which
// meant viewing a Jira issue with inline images would log the user out an
// hour later. The session itself was fine.
//
// Discriminator: the server uses the literal string "Authentication required"
// in the JSON body for canonical session-failed 401s (36 sites in index.js).
// All other 401s use a different `error` value. We clone the response so
// the original is still consumable by the caller.
(() => {
  const _originalFetch = window.fetch.bind(window);
  let loggingOut = false;

  window.fetch = async (input, init = {}) => {
    if (init.credentials === undefined) init = { ...init, credentials: 'same-origin' };
    const response = await _originalFetch(input, init);

    const url = typeof input === 'string' ? input : input?.url || '';
    if (response.status === 401 && url.startsWith('/api/') && !loggingOut
        && !url.includes('/api/auth/login')) {
      // Peek at the body without consuming the original.
      let body = null;
      try { body = await response.clone().json(); } catch { /* not JSON */ }
      if (body?.error === 'Authentication required') {
        loggingOut = true;
        try {
          localStorage.removeItem('dgai_session_expires');
          localStorage.removeItem('dgai_session_user');
          localStorage.removeItem('dgai_session_token');
        } catch { /* ignore */ }
        window.location.reload();
      }
      // Any other 401 (invalid_media_token, slow_down, invalid_grant, ...)
      // is a per-operation failure; pass it back to the caller untouched.
    }

    return response;
  };
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.unregister();
reportWebVitals();
